// extracted by mini-css-extract-plugin
var _1 = "BoardActionsPopup_icon__5lJzU";
export { _1 as "icon" }
